<template>
	<scoped-overflow-layout :loading="!isReady">
		<template #toolbar>
			<v-toolbar flat dense color="white">
				<bar-nav-back @navBack="navBack" />
			</v-toolbar>
		</template>

		<v-container fluid>
			<v-layout>
				<v-flex xs12 sm12 lg8 offset-lg2 xl6 offset-xl3>
					<v-card>
						<feedback-list
							:actionID="id"
							:feedbacks="feedbacks"
							:maxVisibleFeedbacks="0"
							:maxInlineFeedbacks="0"
							@show="navToFeedback" />
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</scoped-overflow-layout>
</template>


<script>
import ScopedOverflowLayout from "@/layouts/ScopedOverflowLayout.vue";
import BarNavBack from "@/components/BarNavBack.vue";
import FeedbackList from '@/components/FeedbackList';

export default {
	name: "feedbacks",
	components: { ScopedOverflowLayout, BarNavBack, FeedbackList },
	props: {
		id: Number,
	},
	data() { return {
		isReady: false,
	}},
	computed: {
		feedbacks() {
			return this.$store.getters['feedbacks/byAction'](this.id);
		},
	},
	methods: {
		async fetchData() {
			this.isReady = false;
			await this.$store.dispatch('feedbacks/fetchByActionID', this.id);
			this.isReady = true;
		},
		navBack() {
			this.$router.go(-1);
		},
		navToFeedback(fdbk) {
			const filter = this.$store.getters['actions/currentRouteFilter'];
			this.$router.push({ name: 'action-feedback', params: { filter, id: this.id, fdbk: fdbk.id } });
		},
	},
	created() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData',
	},
};
</script>
